export interface CookieWallSettings {
    cookieDomain: string;
    categories: CookieWallCategory[];
}

export interface CookieWallCategory {
    title: string;
    category: string;
    description: string;
    required: boolean;
    checked: boolean;
}

export enum CookieWallModal {
    Overview,
    Settings
}

export interface CookieWallContent {
    cookieDomain: string;
    landingPage: LandingPage;
    cookieSettingsPage: SettingsPage;
    blackListedPages: string[];
}

export interface LandingPage {
    pageTitle: string;
    content: string;
    acceptCookiesText: string;
    changeCookiesText: string;
    refuseOptionalCookiesText: string;
}

export interface SettingsPage {
    pageTitle: string;
    content: string;
    categories: SettingsCategory[];
    consentText: string;
    saveButtonText: string;
    cancelButtonText: string;
}

export interface SettingsCategory {
    title: string;
    key: string;
    description: string;
    required: boolean;
}

/// Note: uses capitals in property names for compatibility with PostNL TOL cookie standard
export interface CookiePermissionInfo {
    LastModifiedDate: Date;
    ExpirationDate: Date;
    Allow: boolean;
    CategoryPermission: CategoryPermission[];
}

export interface CategoryPermission {
    Category: string;
    Permission: boolean;
}
